var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpContentType, HttpHeaderType, handleResponse, EnvironmentService, TranslationService, getRandomUuidV4 } from "../../common";
import { QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL, QUESTIONNAIRE_EVALUATION_QUESTION_TYPE } from '../constants';
import { QuestionnaireEvaluationQuestionType } from '../enums';
export class QuestionnaireEvaluationQuestionService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static getInstance() {
        if (!QuestionnaireEvaluationQuestionService.INSTANCE) {
            QuestionnaireEvaluationQuestionService.INSTANCE = new QuestionnaireEvaluationQuestionService();
        }
        return QuestionnaireEvaluationQuestionService.INSTANCE;
    }
    questionnaireEvaluationGetQuestion(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new Request(this.questionnaireEvaluationGetQuestionURI(requestData), {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.ACCEPT_LANGUAGE]: TranslationService.getCurrentLanguage(),
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                })
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
    questionnaireEvaluationGetQuestionURI(requestData) {
        let questionType;
        let questionnaireEvaluationsServiceType;
        switch (requestData.questionType) {
            case QuestionnaireEvaluationQuestionType.FIRST:
                questionType = QUESTIONNAIRE_EVALUATION_QUESTION_TYPE.FIRST;
                questionnaireEvaluationsServiceType = 'QustnnrEvalDocId';
                break;
            case QuestionnaireEvaluationQuestionType.PREVIOUS:
                questionType = QUESTIONNAIRE_EVALUATION_QUESTION_TYPE.PREVIOUS;
                questionnaireEvaluationsServiceType = 'QuestionnaireEvaluations';
                break;
            default:
                questionType = QUESTIONNAIRE_EVALUATION_QUESTION_TYPE.NEXT;
                questionnaireEvaluationsServiceType = 'QustnnrEvalDocId';
                break;
        }
        return `${EnvironmentService.getEnvironment().connectServicesUrl}v1/apd/questionnaire/question/companies/${requestData.companyCode}/questionnaires/${requestData.questionnaireId}/${questionnaireEvaluationsServiceType}/${requestData.evaluationDocId}
		/QuestionnaireQuestionId/${requestData.questionnaireQuestionId}/${questionType}`;
    }
    questionnaireEvaluationGetQuestionaireOutcome(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1/apd/questionnaire/companies/${requestData.companyCode}/QuestionnaireEvaluations/${requestData.evalId}?SystemGeneratedId=${requestData.isSystemGeneratedId}&summary=${requestData.isSummaryAvailable}&includeHistory=${requestData.shouldIncludeHistory}`;
            const request = new Request(uri, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                })
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
    /**
     * Function to call the API to save the override score
     * @param requestData IQuestionnaireEvaluationOverrideScoreRequestData it has data to be send to API
     * @returns response in Response
     */
    questionnaireEvaluationPostOverrideScore(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1/apd/questionnaire/companies/${requestData.companyCode}/QuestionnaireEvaluations/${requestData.evalId}/scoreOverride`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                }),
                body: JSON.stringify(requestData.scoreOverride)
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
}
//# sourceMappingURL=QuestionnaireEvaluationQuestionService.js.map